/**
 * Change Fields breadcrumb origins. Built on the generic `from`-origin helpers in
 * `breadcrumbOrigin.ts`; this module only owns the Change-Fields-specific matcher table.
 *
 * The Change Fields admin page (`/administration/change-fields/`) is reached from the
 * Directory and the Org Chart. Its breadcrumb roots on the page the user came from,
 * carried in the `from` query param, and falls back to the Directory.
 */
import { type OriginMatcher, createOriginParser } from "./breadcrumbOrigin";

export { appendCurrentLocationAsFrom } from "./breadcrumbOrigin";

// Order matters: most-specific paths first.
const ORIGIN_MATCHERS: OriginMatcher[] = [
	{ match: "/org-chart", label: "Org-Chart" },
	{ match: "/directory", label: "Directory" },
];

export const CHANGE_FIELDS_DEFAULT_ORIGIN = { href: "/directory", label: "Directory" } as const;

export type ChangeFieldsOrigin = {
	/** Internal href the root crumb links back to. */
	from: string;
	/** Display label for the originating page. */
	label: string;
};

export const parseChangeFieldsOrigin = createOriginParser(ORIGIN_MATCHERS, CHANGE_FIELDS_DEFAULT_ORIGIN);
